import React from 'react';

import { Box, Button, Paper, Typography } from '@material-ui/core';
import { AiOutlinePlus } from 'react-icons/ai';
import { useHistory } from 'react-router-dom';

import { useStyles } from '@vyce/core/src/views/payroll/styles';
import { usePermissions } from '@vyce/core/src/hooks/usePermissions';
import { PAY_PERMISSIONS } from '@vyce/core/src/types';

import { useTypedSelector } from '../../../hooks';
import { PayScheduleItem } from './PayScheduleItem';

export const PaySchedules: React.FC = () => {
  const classes = useStyles();
  const { selectedCompanyAppData } = useTypedSelector(state => state.helper);
  const history = useHistory();
  const { can } = usePermissions();
  // The Manager role no longer creates pay schedules, so this follows the right
  // rather than the tab: reaching Settings doesn't mean being able to add one.
  const canCreatePaySchedule = can(PAY_PERMISSIONS.CREATE_PAY_SCHEDULES);

  const handleAddPayScheduleClick = () => {
    history.push('/payroll/create-pay-schedule');
  };

  return (
    <Box>
      <Paper variant="outlined" className={classes.wrapper}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography className={classes.bold} variant="h6">
            Pay Schedules
          </Typography>

          {canCreatePaySchedule && (
            <Button
              onClick={handleAddPayScheduleClick}
              startIcon={<AiOutlinePlus />}
              variant="contained"
              size="small"
              color="primary"
            >
              Add Pay Schedule
            </Button>
          )}
        </Box>

        {selectedCompanyAppData?.paySchedules?.map(schedule => (
          <PayScheduleItem key={schedule.uuid} schedule={schedule} />
        ))}
      </Paper>
    </Box>
  );
};
